// extracted by mini-css-extract-plugin
module.exports = {"person-description":"Person_person-description__QrBZC","table":"Person_table__G_F6B"};